import { MeteringType, AnalyzeSettingsType, DatePeriodType, AnalyzeCompareWith } from '@enums';
import { AnalyzeReadingResult } from './analyze-reading-result.model';

export class AnalyzePeriodData {
  settingsType: AnalyzeSettingsType;
  meteringType: MeteringType;
  period: DatePeriodType;
  consumptionData?: AnalyzeReadingResult[];
  consumptionDataCompareYears: number[];
  consumptionDataLoaded: boolean;
  consumptionDataLoading: boolean;
  prognosisData?: AnalyzeReadingResult[];
  prognosisDataLoaded: boolean;
  prognosisDataLoading: boolean;
  meterReadingData?: AnalyzeReadingResult[];
  meterReadingDataLoaded: boolean;
  meterReadingDataLoading: boolean;
  meterReadingType: AnalyzeCompareWith;
  sliderStart: number;
  sliderStop: number;
  dateFrom?: Date;
  dateTo?: Date;
  timeStamp: number;

  public static initalState(periodType: DatePeriodType, settingsType: AnalyzeSettingsType, meteringType: MeteringType) {
    return <AnalyzePeriodData>{
      period: periodType,
      settingsType: settingsType,
      meteringType: meteringType,
      consumptionDataCompareYears: [],
      consumptionData: [],
      consumptionDataLoaded: false,
      consumptionDataLoading: false,
      prognosisData: [],
      prognosisDataLoaded: false,
      prognosisDataLoading: false,
      meterReadingData: [],
      meterReadingDataLoaded: false,
      meterReadingDataLoading: false,
      meterReadingType: AnalyzeCompareWith.Nothing,
      sliderStart: 0,
      sliderStop: 0,
      timeStamp: 0
    };
  }
}

